module.exports = __webpack_public_path__ + "static/media/_ME10936.41568c2e.jpg";